import { GitLabDataName, GitLabDataPlugin } from "@me8eon/gitlab_data_plugin";
import { CompassDataName, CompassDataPlugin } from "@me8eon/compass_data_plugin";
import { MyGeniusDataName, MyGeniusDataPlugin } from "@me8eon/mygenius_data_plugin";
import { OrderItDataName, OrderItDataPlugin } from "@me8eon/order_it_data_plugin";
import { DataPlugins } from "@me8eon/data";
import { JiraDataName, JiraDataPlugin } from "@me8eon/jira_data_plugin";
import { KBArticlesDataName, KBArticlesDataPlugin } from "@me8eon/kb_articles_data_plugin";
import { ConfluenceDataName, ConfluenceDataPlugin } from "@me8eon/confluence_data_plugin";
import { SharepointDataName, SharepointDataPlugin } from "@me8eon/sharepoint_data_plugin";
import { PeopleDataName, PeopleDataPlugin } from "@me8eon/people_data_plugin";
import { AppsDataName, AppsDataPlugin } from "@me8eon/apps_data_plugin";
import { EmailDataName, EmailDataPlugin } from "@me8eon/email_data_plugin";
import { TeamsDataName, TeamsDataPlugin } from "@me8eon/teams_data_plugin";
import { OfficeBuddyDataName, OfficeBuddyDataPlugin } from "../../office_buddy_data/src/officebuddy.data";


export const allDataPlugins: DataPlugins = {
    [AppsDataName]: AppsDataPlugin(),
    [ConfluenceDataName]: ConfluenceDataPlugin(),
    [EmailDataName]: EmailDataPlugin(),
    [GitLabDataName]: GitLabDataPlugin(),
    [JiraDataName]: JiraDataPlugin(),
    [MyGeniusDataName]: MyGeniusDataPlugin(),
    [OrderItDataName]: OrderItDataPlugin(),
    [PeopleDataName]: PeopleDataPlugin(),
    [SharepointDataName]: SharepointDataPlugin(),
    [TeamsDataName]: TeamsDataPlugin(),
    [CompassDataName]: CompassDataPlugin(),
    [KBArticlesDataName]: KBArticlesDataPlugin(),
    [OfficeBuddyDataName]: OfficeBuddyDataPlugin(),
};